@if (_resetPasswordService.resetPasswordStatus(); as resetPasswordStatus) {
  <mat-card class="main-container">
    <mat-card-header>
      <mat-card-title class="header-logo">
        <img src="/assets/images/logo.png" alt="biome-logo" />
      </mat-card-title>
      <mat-card-title class="header-title"
        ><h3 class="title">
          {{
            resetPasswordStatus.type === "success"
              ? isFirstTime()
                ? "Password Created Successfully"
                : "Password Updated Successfully"
              : (isFirstTime()
                  ? "Create Your Password for "
                  : "Reset Your Password for ") + username
          }}
        </h3></mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <br />
      @if (resetPasswordStatus.type !== "success") {
        <form
          [formGroup]="changePasswordForm"
          (ngSubmit)="onSubmit()"
          #ngChangePasswordForm="ngForm"
        >
          <mat-form-field class="form-field">
            <mat-label>New password</mat-label>
            <input matInput formControlName="newPassword" type="password" />
            @if (newPassword?.touched && newPassword.hasError("required")) {
              <mat-error>Password is required</mat-error>
            }
          </mat-form-field>
          <div class="validation">
            <!-- password validation rules -->
            @if (newPassword.dirty) {
              <div class="validation">
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="minLengthValid ? 'success' : 'error'"
                    >{{ minLengthValid ? "check_circle" : "cancel" }}</mat-icon
                  >
                  Must be at least 8 characters long
                </span>
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="requiresDigitValid ? 'success' : 'error'"
                    >{{
                      requiresDigitValid ? "check_circle" : "cancel"
                    }}</mat-icon
                  >
                  Must contain at least 1 digit
                </span>
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="requiresUppercaseValid ? 'success' : 'error'"
                    >{{
                      requiresUppercaseValid ? "check_circle" : "cancel"
                    }}</mat-icon
                  >
                  Must contain at least 1 uppercase character
                </span>
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="requiresLowercaseValid ? 'success' : 'error'"
                    >{{
                      requiresLowercaseValid ? "check_circle" : "cancel"
                    }}</mat-icon
                  >
                  Must contain at least 1 lowercase character
                </span>
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="requiresSpecialCharsValid ? 'success' : 'error'"
                    >{{
                      requiresSpecialCharsValid ? "check_circle" : "cancel"
                    }}</mat-icon
                  >
                  Must contain at least 1 special character
                </span>
              </div>
            }
          </div>
          <mat-form-field class="form-field">
            <mat-label>Confirm password</mat-label>
            <input matInput formControlName="confirmPassword" type="password" />
            @if (
              confirmPassword?.touched && confirmPassword.hasError("required")
            ) {
              <mat-error>Password is required</mat-error>
            }
          </mat-form-field>
          <div class="validation">
            <!-- password validation rules -->
            @if (confirmPassword?.dirty && requiredValid) {
              <div class="validation">
                <span class="validation-status">
                  <mat-icon
                    class="material-symbols-outlined icon"
                    [ngClass]="
                      !confirmPassword.hasError('mismatch')
                        ? 'success'
                        : 'error'
                    "
                    >{{
                      !confirmPassword.hasError("mismatch")
                        ? "check_circle"
                        : "cancel"
                    }}</mat-icon
                  >
                  Password should match
                </span>
              </div>
            }
          </div>
        </form>
      }
      <div
        [ngClass]="{
          'auth-error': resetPasswordStatus.type === 'error',
          'auth-success': resetPasswordStatus.type === 'success',
        }"
      >
        {{
          resetPasswordStatus.message.includes("UnwillingToPerformError")
            ? "Please make sure:"
            : resetPasswordStatus.message
        }}
        @if (resetPasswordStatus.message.includes("UnwillingToPerformError")) {
          <ol>
            <li>
              This password is not one of the previously used five passwords.
            </li>
            <li>The username is not a part of this password.</li>
            <li>This password is not similar to previously used passwords.</li>
            <li>This is not an easily guessable password.</li>
          </ol>
        }
      </div>
      <br />
      @if (_resetPasswordService.resetPasswordStatus().type !== "success") {
        <button
          mat-raised-button
          data-ba-id="changePassword"
          color="primary"
          (click)="onSubmit()"
        >
          {{ isFirstTime() ? "Set Password" : "Update Password" }}
        </button>
      }
      @if (_resetPasswordService.resetPasswordStatus().type === "success") {
        <button
          mat-raised-button
          data-ba-id="continueTologin"
          color="primary"
          [routerLink]="['/login']"
          [queryParams]="username ? { username: username } : null"
        >
          <mat-icon class="material-symbols-outlined">login</mat-icon>
          <div class="login-text-container">
            <span class="login-text">Continue To Login </span>
          </div>
        </button>
      }
      <div class="info-box">
        If you are having trouble updating your password please reach out to
        <a href="mailto:support@biome.io">support&#64;biome.io</a>.
      </div>
    </mat-card-content>
  </mat-card>
}
<ba-support-button />
